import { Chip } from '@mui/material'

import type { AppointmentStatus } from '../../../../types.ts';
import { APPOINTMENT_STATUS_LABELS } from '../../../../types.ts'

export const StatusCell = ({ value }: { value: AppointmentStatus }) => {
  const status = value
  const label = APPOINTMENT_STATUS_LABELS[status] || status
  let color: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' =
    'default'

  switch (status) {
    case 'new':
      color = 'info'
      break
    case 'dispatched':
      color = 'primary'
      break
    case 'cancelled':
      color = 'error'
      break
    case 'completed':
      color = 'success'
      break
    default:
      color = 'default'
  }

  return <Chip label={label} color={color} size="small" />
}
